import Card from "../UI/Card";
import moment from "moment/moment";
import { Form, Formik } from "formik";
import TextArea from "../UI/TextArea";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { object, string } from "yup";
import ToggleSwitch from "../UI/ToggleSwitch";
import CopyToClipboard from "../UI/CopyToClipboard";
import Button from "../UI/Button";
import ManageSubscriptionModal from "./ManageSubscriptionModal";
import { useModal } from "../../hooks/use-modal.jsx";

export default function LogAccountInfo({
  customer,
  submitForm,
  checkCall,
  onSubscriptionUpdate,
  addCustomerCase,
}) {
  const [SubscriptionModal, closeSubscriptionModal, openSubscriptionModal] =
    useModal();
  return (
    <Card>
      <div className="flex align-items-center gap10 wrap">
        <span>
          <strong>Email : </strong> {customer.compte.mail}{" "}
          <CopyToClipboard toCopy={customer.compte.mail} />
        </span>
        <span>
          <strong>Téléphone : </strong> {customer.compte.telephone}{" "}
          <CopyToClipboard toCopy={customer.compte.telephone} />
        </span>
        <span>
          <strong>Activation Code :</strong> {customer.compte.hash}
        </span>
      </div>
      <Card className="padding10 marginT10">
        <div className="flex align-items-center gap10 wrap">
          <span>
            <strong>Abonnement :</strong> {customer.compte.type_abonnement}
          </span>
          <span>
            <strong>Expiration :</strong>{" "}
            {customer.compte.expiration_abonnement
              ? moment(customer.compte.expiration_abonnement).format(
                  "DD/MM/YYYY",
                )
              : "N/A"}
          </span>
          <span>
            <strong>Nb biens :</strong>{" "}
            {customer.compte.nb_biens_abonnement ?? "N/A"}
          </span>
          <span>
            <strong>Autorenew :</strong>{" "}
            {customer.compte.autorenew_abonnement ? "Oui" : "Non"}
          </span>
          <span>
            <strong>Crédits :</strong>{" "}
            {customer.compte.credits != null
              ? `${(customer.compte.credits / 100).toFixed(2)}€`
              : "N/A"}
          </span>
          <Button buttonStyle="secondary" onClick={openSubscriptionModal}>
            Gérer abonnement
          </Button>
        </div>
      </Card>
      <ManageSubscriptionModal
        compte={customer.compte}
        onSave={onSubscriptionUpdate}
        addCustomerCase={addCustomerCase}
        onClose={closeSubscriptionModal}
        modal={SubscriptionModal}
      />
      {customer.cases.map((customerCase, i) => (
        <Card className={"padding10 marginT10"} key={i}>
          <p className={"secondaryText text-right"}>
            le {moment(customerCase.date_add).format("DD/MM/YYYY")} par{" "}
            {customerCase.auteur}
          </p>
          <p>{customerCase.commentaire}</p>
        </Card>
      ))}
      <Card className={"padding10 marginT10"}>
        <Formik
          initialValues={{
            commentaire: "",
            initial_call: customer.compte.initial_call ?? false,
          }}
          enableReinitialize={true}
          validationSchema={object({
            commentaire: string().required("Commentaire requis"),
          })}
          onSubmit={submitForm}
        >
          <Form>
            <TextArea name={"commentaire"}></TextArea>
            <ToggleSwitch
              status={customer.compte.initial_call}
              onToggle={() => {
                checkCall(customer.compte);
              }}
            />{" "}
            Appel initial
            <div className={"text-right"}>
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </div>
          </Form>
        </Formik>
      </Card>
    </Card>
  );
}
